import {
  createElement,
  CSSProperties,
  memo,
  ReactNode,
} from 'react';
import cx from 'classnames';
import s from './BText.module.scss';
import { BColors } from '../lib/consts/common';

type BTextColor = BColors;
type BTextSize = 'sm' | 'm' | 'l' | 'x';
type BTextDisplay = 'block' | 'inline' | 'inline-block' | 'flex';
type TextTag = | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'li'
type TextAlight = 'left' | 'right' | 'center';
type TextWeight = 'light' // 300
  | 'regular' // 400
  | 'medium' // 500
  | 'semi-bold' // 600
  | 'bold' // 700
  | 'extra-bold' // 800
  | 'black' // 900

export interface BTextProps {
  className?: string;
  color?: BTextColor;
  children: ReactNode;
  display?: BTextDisplay;
  tag?: TextTag;
  size?: BTextSize;
  weight?: TextWeight;
  align?: TextAlight;
  style?: CSSProperties;
}

export const BText = memo<BTextProps>((props: BTextProps) => {
  const {
    className,
    children,
    weight = 'regular',
    display = 'block',
    size = 'm',
    color = 'dark',
    tag = 'p',
    align = 'left',
    style,
  } = props;

  const additional = [
    className,
    s[color],
    s[align],
    s[tag],
    s[size],
    s[display],
    s[`weight-${weight}`],
  ];

  return createElement(
    tag,
    {
      className: cx(
        s.text,
        additional,
      ),
      style,
    },
    children,
  );
});
